import { EnvironmentConfig } from '@gde-mit/angular-core';

import { AppConfig } from '../app-settings.service';

type ConfiguredEnvironment = AppConfig & { APP_CONFIG_PATH: string };

type RuntimeEnvironment = EnvironmentConfig<ConfiguredEnvironment>;

/**
 * `EnvironmentConfig` types every scalar as `any`; for the keys listed here the type follows `AppConfig`.
 * `config.json` overwrites `ENVIRONMENT` at runtime without a check, so this states the config contract, not a
 * runtime guarantee.
 */
type TypedKey = 'GOOGLE_TAG_MANAGER_ID' | 'SENTRY';

export const ENVIRONMENT: {
  [K in keyof RuntimeEnvironment]: K extends TypedKey ? ConfiguredEnvironment[K] : RuntimeEnvironment[K];
} = {
  API_URL: '',
  MEDIA_BASE_URL: '',
  APP_CONFIG_PATH: 'config.json',
  SENTRY: {
    DSN: '',
    ENVIRONMENT: '',
  },
  USE_MOCK: false,
  LOGIN_APP_FE_URL: '',
  LOGIN_APP_BE_URL: '',
  // The Application whose tenants the LoginApp offers on a handoff. Empty means "not configured", which
  // reproduces the pre-MTP redirect exactly.
  MTP_APPLICATION_CODE: '',
  APPS_URLS__EXERCISES: '',
  APPS_URLS__WIKI: '',
  APPS_WIKI_ENABLED: '',
  GOOGLE_TAG_MANAGER_ID: '',
  LEGAL: {
    PRIVACY_POLICY_URL: '',
    TERMS_OF_USE_URL: '',
  },
  REFINER: {
    PROJECT_ID: '',
    BUG_REPORT_FORM_ID: '',
    GENERAL_FEEDBACK_FORM_ID: '',
    SURVEYS_FORM_ID: '',
    HELP_CONTACT_FORM_ID: '',
  },
  DEFAULT_LANG: 'hu',
  DOCUMENT_UPLOAD: {
    MAX_FILE_SIZE_BYTES: 51_380_224,
    ALLOWED_EXTENSIONS: 'pdf,docx',
  },
  CKEDITOR: {
    LICENSE_KEY: '',
    IMAGE_UPLOAD: {
      ENABLED: false,
    },
  },
  STICKER: {
    DOWNLOAD_FILE_NAME_PREFIX: 'matrica',
  },
  COVER: {
    GENERATION_ENABLED: false,
    DOWNLOAD_FILE_NAME_PREFIX: 'boritokep',
  },
};
